export default __webpack_public_path__ + "static/cardImg2-e9ddb2e8e08e5569cb60414f5be77b61.webp";